// currently used for ridertag and site page lists
<template>
    <div class="">
        <div class="header-panel">
            <div class="container">
       <div class="page-results-list">
            <!-- <Heading v-if="field == 'ridertags'"
                :heading = "displayMap[field] + ' ' + tagkey"
                :noTitleCase = "true"
           /> -->
            <!-- <div class="spacer" style="height:80px"></div> -->

            <Breadcrumb 
                :levelTwoText = "field == 'ridertags' ? 'Rider Tags' : 'Blogs'"
                :levelTwoLink = "field == 'ridertags' ? '/ridertags' : '/sites'"
                :levelThreeText = "tagkey"
            
            />
            <div v-if="field == 'ridertags'">
                <!-- <div class="spacer" style="height:80px"></div> -->
                <Heading 
                    :heading = "$titleCase(tagkey)"
                    :preheading="'Bike Travel Featuring the Tag'"
                    :noSpaceBelow = "true"
                    :level = "1"
                />
                <TOC v-if="booksByRidertag.length > 0"
                :slot1text="'Blogs'"
                :slot1link="'blogs'"
                :slot2text="booksByRidertag.length > 0 ? 'Books' : ''"
                :slot2link="booksByRidertag.length > 0 ? 'books' : ''"
                />
                <div class="spacer" style="height:30px"></div>
                
                
            </div>


            <div v-if="field == 'site_domain'">
                <!-- <div class="spacer" style="height:80px"></div> -->
                <Heading 
                    :heading = "tagkey"
                    :preheading="'Blog Posts From'"
                    :noSpaceBelow = "false"
                />
                <!-- <h2>
                    <span class='title is-size-5 is-size-6-mobile' style="margin-top:0px; margin-bottom:0; text-transform:uppercase">Blog Posts From</span><br>
                    <span class='title is-size-2 is-size-4-mobile' style="margin-bottom:0">{{tagkey}}</span>

                </h2> -->
                <!-- <div v-if="!subheading" class="spacer" style="height:40px"></div> -->
                
            </div>
       </div>

       </div>
        </div>
        <div class="container">
            <div class="spacer" style="height:30px"></div>
            <Heading v-if="field == 'ridertags'"
                :heading = "'Blog Posts'"
                :anchor = "'blogs'"
                :smaller="true"
            />
           <div class="spacer" style="height:30px"></div>
            <!-- <h1 class="title is-3">{{displayMap[field] + " " + tagkey}}</h1> -->
            <div class="columns is-multiline is-variable is-4-desktop">
                <PageResultColumns  
                    v-for="(page, idx) in this.pages"
                    v-bind:key = idx 
                    :page = "page"
                    :approveMode = "false"
                    :showYear="true"
                />
            </div>

                <div class="section card" ref="results" v-if="isLoading">
                    <b-icon class="fas fa-spinner fa-spin"></b-icon>
                    Loading...
                </div>
                <div class="section card" ref="results" v-if="!isLoading && pages.length == 0">
                    <!-- <b-icon class="fas fa-spinner fa-spin"></b-icon> -->
                    None yet :(  You can <router-link to="/add">submit a blog post</router-link> to start filling this section.
                </div>
                <div class="spacer" style="height:60px"></div>

                <b-button type="is-primary is-large" style="margin-bottom:10px" v-if="!noMorePages && pages.length > 0" @click="nextPage" v-scroll-to="{
                        el:'#result-last',
                        easing:'ease',
                        offset: -100
                    
                }">Load more</b-button>
                <!-- <div v-if="activeFilterCount > 0" style="padding: 30px 0px; font-size: 18px; text-align:left">To see more results, <a v-on:click="clearFilters">click here to clear filters</a></div> -->
                <b-button v-if="pages.length > 0" v-scroll-to="'#app'" class="is-large">Scroll to top</b-button>
                <div class="spacer" style="height:80px"></div>
                

                <div class="spacer" style="height:60px"></div>  
        

            <div class="books" v-if="field == 'ridertags' && booksByRidertag.length > 0">
                <div class="spacer" style="height:80px"></div>
                <div class="divider"></div>
                <div class="spacer" style="height:80px"></div>

                <Heading 
                    :anchor="'books'"
                    :heading = "'Bike Travel Books'"
                    :subheading = "'Featuring the Tag \'' + $titleCase(tagkey) + '\''"
                />
                
                <!-- <h3 class='title is-size-2 is-size-3-mobile' style="margin-bottom:5px" >Book Directory</h3>
                <span class='title is-size-5 is-size-6-mobile' style="margin-top:0px !important; text-transform:uppercase">{{tagkey}}</span> -->
                <div class="spacer" style="height:50px"></div>

                <div class="columns is-multiline is-variable is-3-desktop" v-if="!isLoading">
                <Book  
                    v-for="book in booksByRidertag"
                    v-bind:key = book.id
                    :bookObj="book"
                    />
                </div>
                <router-link to="/books/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all books</router-link>
                <div class="spacer" style="height:30px"></div>
                <p class="is-size-7 is-size-7-mobile">Some book links are affiliate links, which means BikeSleepBike may earn a small commission at no extra cost to you if you buy something through them.
                        The money helps pay for hosting and infrastructure costs of running this website. As an Amazon Associate I earn from qualifying purchases. Thanks!

                    </p>
            </div>

            <div class="spacer" style="height:100px"></div>
        </div>
        </div>
    <!-- </div>   -->
</template>

<script>
// import {allcountries} from "../data.js";
import CustomTagInput from '@/components/CustomTagInput';
// import AdminApproveNewPage from '@/components/AdminApproveNewPage';
import Login from '@/components/Login';
import PageResultColumns from '@/components/PageResultColumns';
import Heading from '@/components/Heading';
import Breadcrumb from '@/components/Breadcrumb';
import Book from '@/components/Book';
import TOC from '@/components/TOC';

export default {
    name: 'PageResultsList',
    components: { Heading, PageResultColumns, Breadcrumb, Book, TOC},
    props: ["ridertag", "site"],
    data () {
        return {
            pages:[],
            tagkey:"",
            field: "",
            operator: "",
            displayMap: { ridertags: "Rider Tag: ", site_domain: "Posts From", 'black woman': "Black woman"},
            isLoading: false,
            noMorePages: false,
            lastVisibleResult: undefined,
            currentQuery: undefined,
            queryLimit: 21,
            booksByRidertag: [],
        }
    
    },
    watch: {
        "$route.params.ridertag"(val) {
            this.parseUrl();
        // call the method which loads your initial state
            this.loadNewPages();
            this.fetchBooksByRidertag(this.tagkey);
        },
        "$route.params.site"(val) {
            this.parseUrl();
        // call the method which loads your initial state
            this.loadNewPages();
            this.fetchBooksByRidertag(this.tagkey);
        },
    },
    
    methods: {
     
        loadNewPages() {
            // console.log("operator");
            // console.log(this.operator);
            var that = this;
            this.isLoading = true;
            var that = this;
            var result = [];
            this.noMorePages = false;
            this.lastVisibleResult = undefined;
            // console.log(this.tagkey);
            this.currentQuery = this.$db.collection("pages").where(this.field, this.operator, this.tagkey).orderBy("year", "desc").orderBy("added", "desc");
            this.$db.collection("pages").where(this.field, this.operator, this.tagkey).orderBy("year", "desc").orderBy("added", "desc").limit(that.queryLimit)
                .get()
                .then(function(querySnapshot) {
                    var result = [];
                    querySnapshot.forEach(function(doc) {
                        const idObj = {id: doc.id};
                        result.push({...idObj, ...doc.data()});
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    // that.resultPages = result;
                    that.isLoading = false;
                    that.pages = result;
                })
                .catch(function(error) {
                    console.log("Error getting documents: ", error);
                    that.isLoading = false;
                });
        },
        nextPage() {
            if (this.$debug) {console.log("DEBUG: In function nextPage");}
            var that = this;
            var result = [];  
        
            if (this.lastVisibleResult) {
                this.noMorePages = false;
                this.currentQuery.startAfter(this.lastVisibleResult).limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.pages.push(...result);
                });         
            } else {
                this.noMorePages = true;
            }
        },
        fetchBooksByRidertag(ridertag) {
            if (this.$debug) {console.log("DEBUG: In function fetchBooksByRidertag");}
        
        // if (value != "") { // GET FILTERED
            this.$analytics.logEvent('fetch_results', { type: 'books by ridertag', value: ridertag});
            var that = this;
            var result = [];
           
            this.$db.collection("books").where('ridertags', 'array-contains', ridertag).orderBy("title", "asc").limit(8).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                   
                    that.booksByRidertag = result;
                    // console.log(that.booksByRidertag);
                    // that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting books by route: ", error);
                    // that.isLoading = false;
                });
        // } 
        },
        parseUrl() {
            // console.log(this.tagkey);
            if (this.$debug) {console.log("DEBUG: In function parseUrl");}
            if (this.ridertag) {
                this.field = "ridertags";
                this.operator = "array-contains";
                if (this.displayMap[this.ridertag]) {
                    this.tagkey = this.displayMap[this.ridertag];
                } else {
                    this.tagkey = this.ridertag;
                }
                
            } else if (this.site) {
                this.field = "site_domain";
                this.operator = "==";
                this.tagkey = this.site;
            } 
            // console.log(this.tagkey);
        }
        
    },
     metaInfo() {
        var title =  (this.field == 'site_domain' ? this.tagkey : this.$titleCase(this.tagkey) ) + " - Bicycle Touring Blogs";
        var description = title + " at BikeSleepBike, a directory of bicycle touring and bikepacking blogs from all over the world.";
        return {
            title: title,
            titleTemplate: this.$titleTemplate,
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    

  },
    beforeRouteEnter(to, from, next) {
      next(component => {
        //   if (component.type == 'routes') {
            //   component.getRoutes();
        //   } else {
        //       this.parseUrl();
        // this.loadNewPages();
        // this.fetchBooksByRidertag(this.tagkey);
        //   }
          
      })
  },
  beforeRouteChange(to, from, next) {
    //   if (this.type == 'routes') {
        //   this.getRoutes();
    //   } else {
        // this.parseUrl();
        // this.loadNewPages();
        // this.fetchBooksByRidertag(this.tagkey);
        // console.log("mounted");
    //   }
      
  },
    mounted() {
        // console.log("mounted");
        this.parseUrl();
        this.loadNewPages();
        if (this.field == "ridertags") {
            this.fetchBooksByRidertag(this.tagkey);
        }
        
      
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  
</style>




// WEBPACK FOOTER //
// src/components/PageResultsList.vue